import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './Router/router';
import 'boxicons/css/boxicons.min.css';

function App() {
  return (
    <div className="App">
      <RouterProvider router = {router}/>
      {/* <h1>HelpNao</h1> */}
    </div>
  );
}

export default App;
